module.exports = __webpack_public_path__ + "img/_france.720da539.png";